import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-taupe text-cream relative" data-id="element-173">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-174">
        <div className="text-center mb-12" data-id="element-175">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-176">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>
          <p className="text-xl font-body text-cream/80 max-w-2xl mx-auto" data-id="element-177">
            No esperes a que tu ropa deje de quedarte por completo. Empieza tu
            transformación esta misma noche.
          </p>
        </div>

        <Card className="bg-cream text-taupe p-8 md:p-12 max-w-2xl mx-auto shadow-2xl transform hover:scale-[1.02] transition-transform duration-300" data-id="element-178">
          <div className="text-center mb-8" data-id="element-179">
            <p className="text-2xl text-taupe-light font-body line-through mb-1" data-id="element-180">
              $15,99 USD
            </p>
            <p className="text-sm font-body font-bold text-gold uppercase tracking-wider mb-2" data-id="element-181">
              Ahora Inversión Única
            </p>
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-182">
              <span className="text-6xl font-bold text-gold" data-id="element-183">$6.39</span>
              <span className="text-xl text-taupe-light font-body mt-4" data-id="element-184">
                USD
              </span>
            </div>
            <p className="font-body text-taupe-light" data-id="element-185">
              Recibirás el sistema completo{' '}
              <strong data-id="element-186">Metabolismo Silver 21</strong> al instante.
            </p>
          </div>

          <div className="space-y-6" data-id="element-187">
            <Button size="lg" fullWidth className="text-lg shadow-glow" onClick={() => window.open('https://tumundoequilibrado.com/cart/51130100384039:1', '_blank', 'noopener,noreferrer')} data-id="element-188">
              ¡QUIERO MI COPIA DE METABOLISMO SILVER 21!
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm font-body text-taupe-light" data-id="element-189">
              <div className="flex items-center gap-2" data-id="element-190">
                <LockIcon className="w-4 h-4 text-olive" data-id="element-191" />
                <span data-id="element-192">Pago seguro con encriptación SSL</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-193">
                <ShieldCheckIcon className="w-4 h-4 text-olive" data-id="element-194" />
                <span data-id="element-195">Acceso instantáneo tras la compra</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}